import { FadeUp } from "@/components/Reveal";

export default function TrustStrip() {
  return (
    <section id="trust" data-testid="trust-strip" className="border-y hairline py-14 md:py-20">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <FadeUp>
          <p className="text-[11px] md:text-xs uppercase tracking-[0.35em] text-muted text-center">
            Trusted by photographers, agencies &amp; property professionals worldwide
          </p>
        </FadeUp>
      </div>
    </section>
  );
}
